import { useState } from "react";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import { storeApplicationPaymentWithoutCategories } from "../../../services/cms/walkthroughCmsSubmit";
import { isAccountFeePaid } from "../../../services/accountFee";
import RightArrow from "../../icons/links/right_arrow_circle.svg";

const OneCalculatedBox = ({ type, content, percent, link, userData }) => {
  const router = useRouter();
  const [isLoading, setIsLoading] = useState(false);
  const feePaid = isAccountFeePaid(userData);

  const stripePortal = async () => {
    if (feePaid || isLoading) {
      router.push("/dashboard");
      return;
    }

    setIsLoading(true);

    try {
      const response = await storeApplicationPaymentWithoutCategories({
        return_url: `${process.env.NEXT_PUBLIC_BASE_HOST}/dashboard`,
      });

      if (response.status === 200) {
        const info = await response.json();
        if (info.already_paid) {
          router.push("/dashboard");
          return;
        }
        if (info.url) {
          router.push(info.url);
        }
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="oneCalculatedBox">
      <p className="oneCalculatedBox__header">{content}</p>
      <div className="oneCalculatedBox__percent">
        <p
          className={`${percent === 100 && "oneCalculatedBox__percentActive"}`}
        >
          {percent}%
        </p>
        {type === "link" && (
          <Link href={link} prefetch={false}>
            <a>
              <Image
                src={RightArrow}
                height="32"
                width="32"
                alt="link to complete section"
              />
            </a>
          </Link>
        )}

        {type === "function" && feePaid && (
          <p style={{ fontSize: "0.85rem", margin: 0 }}>Paid</p>
        )}

        {type === "function" && !feePaid && (
          <button
            type="button"
            onClick={stripePortal}
            disabled={isLoading}
            className="oneCalculatedBox__stripe"
            style={{
              border: "none",
              background: "transparent",
              padding: 0,
              cursor: isLoading ? "wait" : "pointer",
              opacity: isLoading ? 0.6 : 1,
            }}
            aria-label="Proceed to application fee payment"
          >
            <Image
              src={RightArrow}
              height="32"
              width="32"
              alt="link to complete section"
            />
          </button>
        )}
      </div>
    </div>
  );
};

export default OneCalculatedBox;
